/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PauseAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function PauseAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content/Started/Pause/Details/PauseAction",
  onSubmit,
  isSubmitting
  
}) {
let selectedResumeDateSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected',
})
let selectedResumeDateIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginTop="auto"
 data="selected.resume_date"
 validate="/Data/validate.js dateFuture"
 onClick={selectedResumeDateSubmitData}
 disabled={selectedResumeDateIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Pause"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}